/* eslint-disable import/prefer-default-export */
import { Modal as PolarisModal } from "@shopify/polaris";
import Modal from "./Modal";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Modal.Section = PolarisModal.Section;

export default Modal as typeof Modal & { Section: typeof PolarisModal.Section };
